const PARTNERS = [
  {
    name: 'پست',
    descriptor: 'ارسال مرسولات پستی',
    live: false,
  },
  {
    name: 'سها پیک',
    descriptor: 'ارسال با پیک در مسیرهای یزد',
    live: true,
  },
  {
    name: 'تیپاکس',
    descriptor: 'ارسال سریع بین‌شهری',
    live: false,
  },
  {
    name: 'چاپار',
    descriptor: 'ارسال سراسری کالا',
    live: false,
  },
];

export default function DeliveryPartners() {
  return (
    <section className="card delivery-partners" aria-labelledby="delivery-partners-title">
      <header className="delivery-partners__header">
        <h2 className="about-section-title" id="delivery-partners-title">
          <i className="fas fa-truck" aria-hidden="true" />
          همکاران ارسال
        </h2>
        <p className="about-section-text">
          سهاپیک در مسیرهای یزد فعال است و سرویس‌های ارسال دیگر به‌زودی اضافه می‌شوند.
        </p>
      </header>

      <ul className="delivery-partners__grid">
        {PARTNERS.map((partner) => (
          <li className="delivery-partners__card" key={partner.name}>
            <div className="delivery-partners__card-heading">
              <h3>{partner.name}</h3>
              {!partner.live && (
                <span className="delivery-partners__badge">به‌زودی</span>
              )}
            </div>
            <p>{partner.descriptor}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
